<div class="bg-gray-900 p-2 sticky top-0 right-0 left-0 z-">
	<div class="grid grid-cols-3 items-center">
		<span class="text-xl text-white font-bold justify-self-start">
			<ms-button icon="far fa-arrow-left" title="Voltar" (click)="onGoBack()"></ms-button>
		</span>
		<span class="text-xl text-white font-bold justify-self-center">{{ header }}</span>
		<div class="justify-self-end">
			<ng-container *ngTemplateOutlet="headerRightTemplate"></ng-container>
		</div>
	</div>
</div>
<div class="p-5 pb-15">
	<ng-content></ng-content>
</div>
<div class="bg-gray-900 p-2 fixed bottom-0 right-0 left-0 w-full-dynamic">
	<div class="flex flex-row justify-end gap-3 mr-5">
		<ng-container *ngTemplateOutlet="footerRightTemplate"></ng-container>
	</div>
</div>
